export function user (state, user) {
  state.user = user
}

export function pageTitle(state, pageTitle) {
  state.pageTitle = pageTitle
}

export function currentWeekPerProgram(state, {currentWeek, key}) {
  state.currentWeekPerProgram[key] = currentWeek
}

export function paymentsEnabled(state, paymentsEnabled) {
  state.paymentsEnabled = paymentsEnabled
}


